<div class="row">
  <div class="col-12 col-lg-6">
    <div class="pair-container" *ngFor="let item of keyValuePairs; let i = index">
      <input
        [(ngModel)]="item.key"
        placeholder="Clave"
        class="input"
        (ngModelChange)="onKeyChange(i);"
        (keydown)="filterKey($event)"
      />
      <input
        [(ngModel)]="item.value"
        placeholder="Valor"
        class="input"
        (ngModelChange)="buildObject();"
      />
      <em class="fa fa-times text-danger c-pointer" (click)="removePair(i)"></em>
    </div>

    <div class="actions">
      <button class="btn btn-primary" type="button" (click)="addPair()">
        <em class="fa fa-plus"></em> {{ "general.add" | translate }}
      </button>
    </div>
  </div>
  <div class="col-12 col-lg-6">
    <pre class="output">{{ object | json }}</pre>
  </div>
</div>
